import React from "react";
import { Field, money } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Plus, Trash } from "@phosphor-icons/react";

const num = (v) => Number(v) || 0;
const inp = "bg-white border-slate-300";

export function FactoringFields({ value, onChange }) {
  const setItem = (idx, key, val) => onChange({ ...value, items: value.items.map((it, i) => (i === idx ? { ...it, [key]: val } : it)) });
  const addItem = () => onChange({ ...value, items: [...value.items, { description: "", quantity: 1, rate: "" }] });
  const removeItem = (idx) => onChange({ ...value, items: value.items.filter((_, i) => i !== idx) });
  const total = value.items.reduce((s, it) => s + (num(it.quantity) || 1) * num(it.rate), 0);

  return (
    <div className="space-y-4 mt-1" data-testid="inv-factoring-fields">
      <Field label="Factoring Company Name *">
        <Input value={value.company} onChange={(e) => onChange({ ...value, company: e.target.value })} placeholder="e.g. RTS Financial" className={inp} data-testid="inv-factoring-company" />
      </Field>
      <div>
        <p className="text-xs font-bold uppercase tracking-wide text-slate-400 mb-2">Line Items</p>
        <div className="space-y-2">
          {value.items.map((it, i) => (
            <div key={i} className="grid grid-cols-[1fr_70px_120px_32px] gap-2 items-center">
              <Input value={it.description} onChange={(e) => setItem(i, "description", e.target.value)} placeholder="e.g. Commission – May 2026" className={inp} data-testid={`inv-factoring-desc-${i}`} />
              <Input type="number" min="1" value={it.quantity} onChange={(e) => setItem(i, "quantity", e.target.value)} className={`${inp} font-mono`} data-testid={`inv-factoring-qty-${i}`} />
              <Input type="number" value={it.rate} onChange={(e) => setItem(i, "rate", e.target.value)} placeholder="Amount $" className={`${inp} font-mono`} data-testid={`inv-factoring-rate-${i}`} />
              <button onClick={() => removeItem(i)} disabled={value.items.length === 1} className="p-1.5 text-slate-400 hover:text-red-500 disabled:opacity-30" data-testid={`inv-factoring-del-${i}`}><Trash size={15} /></button>
            </div>
          ))}
        </div>
        <Button variant="outline" onClick={addItem} className="mt-2 h-8 border-slate-300 bg-white text-slate-700 text-xs" data-testid="inv-factoring-add-item"><Plus size={14} className="mr-1" />Add Line</Button>
      </div>
      <Field label="Notes"><Textarea value={value.notes} onChange={(e) => onChange({ ...value, notes: e.target.value })} rows={2} className={inp} data-testid="inv-factoring-notes" /></Field>
      <div className="flex justify-end text-sm"><span className="text-slate-500 mr-3">Invoice Total</span><span className="font-mono font-extrabold text-lg text-slate-900" data-testid="inv-factoring-total">{money(total)}</span></div>
    </div>
  );
}
